import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const UpdatePowerGenerationPlant = () => {
  const { id } = useParams();

  const [formData, setFormData] = useState({
    power_id: "",
    genplant_name: "",
    genplant_address: "",
    genplant_city: "",
    genplant_district: "",
    genplant_state: "",
    genplant_pincode: "",
    genplant_phone: "",
    genplant_email: "",
    genplant_website: "",
  });

  const [errors, setErrors] = useState({});
  const [statusMessage, setStatusMessage] = useState("");

  useEffect(() => {
    const fetchPlant = async () => {
      try {
        const res = await fetch(`https://backend-zkgn.onrender.com/api/plants/${id}`);
        const data = await res.json();

        if (res.ok && data) {
          setFormData({
            power_id: data.power_id || "",
            genplant_name: data.genplant_name || "",
            genplant_address: data.genplant_address || "",
            genplant_city: data.genplant_city || "",
            genplant_district: data.genplant_district || "",
            genplant_state: data.genplant_state || "",
            genplant_pincode: data.genplant_pincode || "",
            genplant_phone: data.genplant_phone || "",
            genplant_email: data.genplant_email || "",
            genplant_website: data.genplant_website || "",
          });
        }
      } catch (err) {
        console.error("Failed to fetch plant:", err);
      }
    };

    fetchPlant();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const tempErrors = {};

    if (!formData.genplant_name)
      tempErrors.genplant_name = "Plant name is required.";
    if (!formData.genplant_address)
      tempErrors.genplant_address = "Address is required.";
    if (!formData.genplant_city)
      tempErrors.genplant_city = "City is required.";
    if (!formData.genplant_district)
      tempErrors.genplant_district = "District is required.";
    if (!formData.genplant_state)
      tempErrors.genplant_state = "State is required.";
    if (!formData.genplant_pincode)
      tempErrors.genplant_pincode = "Pincode is required.";

    if (!formData.genplant_email) {
      tempErrors.genplant_email = "Email is required.";
    } else {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(formData.genplant_email)) {
        tempErrors.genplant_email = "Please enter a valid email address.";
      }
    }

    if (!formData.genplant_website)
      tempErrors.genplant_website = "Website is required.";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const res = await fetch(`https://backend-zkgn.onrender.com/api/plants/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setStatusMessage("Plant updated successfully!");
      } else {
        setStatusMessage("Failed to update plant.");
      }
    } catch (err) {
      console.error("Error updating plant:", err);
      setStatusMessage("An error occurred while updating.");
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Update Power Generation Plant</h3>
      {statusMessage && <div className="alert alert-info">{statusMessage}</div>}

      <form onSubmit={handleSubmit}>
        <div className="row g-3">

          {/* Plant ID */}
          <div className="col-md-6">
            <label className="form-label">Plant ID</label>
            <input
              type="text"
              className="form-control"
              name="power_id"
              value={formData.power_id}
              readOnly
            />
          </div>

          {/* Plant Name */}
          <div className="col-md-6">
            <label className="form-label">Plant Name</label>
            <input
              type="text"
              className={`form-control ${errors.genplant_name ? "is-invalid" : ""}`}
              name="genplant_name"
              value={formData.genplant_name}
              onChange={handleChange}
            />
            {errors.genplant_name && (
              <div className="text-danger">{errors.genplant_name}</div>
            )}
          </div>

          {/* Address */}
          <div className="col-12">
            <label className="form-label">Address</label>
            <textarea
              className={`form-control ${errors.genplant_address ? "is-invalid" : ""}`}
              name="genplant_address"
              rows="2"
              value={formData.genplant_address}
              onChange={handleChange}
            ></textarea>
            {errors.genplant_address && (
              <div className="text-danger">{errors.genplant_address}</div>
            )}
          </div>

          {/* City */}
          <div className="col-md-6">
            <label className="form-label">City</label>
            <input
              type="text"
              className={`form-control ${errors.genplant_city ? "is-invalid" : ""}`}
              name="genplant_city"
              value={formData.genplant_city}
              onChange={handleChange}
            />
            {errors.genplant_city && <div className="text-danger">{errors.genplant_city}</div>}
          </div>

          {/* District */}
          <div className="col-md-6">
            <label className="form-label">District</label>
            <input
              type="text"
              className={`form-control ${errors.genplant_district ? "is-invalid" : ""}`}
              name="genplant_district"
              value={formData.genplant_district}
              onChange={handleChange}
            />
            {errors.genplant_district && (
              <div className="text-danger">{errors.genplant_district}</div>
            )}
          </div>

          {/* State */}
          <div className="col-md-6">
            <label className="form-label">State</label>
            <input
              type="text"
              className={`form-control ${errors.genplant_state ? "is-invalid" : ""}`}
              name="genplant_state"
              value={formData.genplant_state}
              onChange={handleChange}
            />
            {errors.genplant_state && (
              <div className="text-danger">{errors.genplant_state}</div>
            )}
          </div>

          {/* Pincode */}
          <div className="col-md-6">
            <label className="form-label">Pincode</label>
            <input
              type="text"
              className={`form-control ${errors.genplant_pincode ? "is-invalid" : ""}`}
              name="genplant_pincode"
              value={formData.genplant_pincode}
              onChange={handleChange}
            />
            {errors.genplant_pincode && (
              <div className="text-danger">{errors.genplant_pincode}</div>
            )}
          </div>

          {/* Phone */}
          <div className="col-md-6">
            <label className="form-label">Phone</label>
            <input
              type="text"
              className="form-control"
              name="genplant_phone"
              value={formData.genplant_phone}
              onChange={handleChange}
            />
          </div>

          {/* Email */}
          <div className="col-md-6">
            <label className="form-label">Email</label>
            <input
              type="email"
              className={`form-control ${errors.genplant_email ? "is-invalid" : ""}`}
              name="genplant_email"
              value={formData.genplant_email}
              onChange={handleChange}
            />
            {errors.genplant_email && (
              <div className="text-danger">{errors.genplant_email}</div>
            )}
          </div>

          {/* Website */}
          <div className="col-md-6">
            <label className="form-label">Website</label>
            <input
              type="url"
              className={`form-control ${errors.genplant_website ? "is-invalid" : ""}`}
              name="genplant_website"
              value={formData.genplant_website}
              onChange={handleChange}
            />
            {errors.genplant_website && (
              <div className="text-danger">{errors.genplant_website}</div>
            )}
          </div>

        </div>

        <div className="mt-4">
          <button type="submit" className="btn btn-primary">Update</button>
        </div>
      </form>
    </div>
  );
};

export default UpdatePowerGenerationPlant;
